var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"main-box"},[_c('HeaderNav'),_c('div',{staticClass:"m-router-view"},[_c('router-view')],1),_c('FooterNav')],1),(_vm.isClose)?_c('Wallet'):_vm._e(),_c('Toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }